import { registerPlugin } from '@capacitor/core';
const CapacitorAxaMobileSdk = registerPlugin('CapacitorAxaMobileSdk', {
    web: () => import('./web').then(m => new m.CapacitorAxaMobileSdkWeb()),
});
export * from './definitions';
export { CapacitorAxaMobileSdk };
//# sourceMappingURL=index.js.map